import React, { FC } from "react";
import { useDispatch } from "react-redux";

import { Box } from "ui-library/layouts";
import { HtmlLink, Typography } from "ui-library/atoms";

import auth from "core/auth";
import i18n from "core/i18n";
import { useGetSiteValue, useHasRole } from "core/hooks";
import { ExternalUrl, Roles } from "enums";

export const ERegistryInfoText: FC = () => {
    const { t } = i18n.useTranslation();
    const dispatch = useDispatch();

    const isAuthenticated = useHasRole(Roles.AUTHENTICATED);
    const getSiteValue = useGetSiteValue();

    return (
        <Box fullWidth mb={3}>
            {isAuthenticated ? (
                <Typography markDown={t("change.tab.loggedUserNote", { link: getSiteValue(ExternalUrl.E_REGISTRY_DISPATCH) })} />
            ) : (
                <Typography>
                    {t("change.tab.oneTimeUserNote.part1")}
                    <HtmlLink onClick={() => dispatch(auth.logOut(auth.LogoutAction.REDIRECT_TO_E_REGISTRY))}>
                        {t("change.tab.oneTimeUserNote.linkText")}
                    </HtmlLink>
                    {t("change.tab.oneTimeUserNote.part2")}
                </Typography>
            )}

            <br />
            <Typography markDown={t("change.tab.oneTimeUserNote.digiSignRequirements")} />
        </Box>
    );
};
